import { Apis } from "libs/apis";

export const useRetailerOnboarding = () => {
  const toggleOnBoardingStatus = async (retailerId: string) => {
    try {
      const res = await Apis.toggleOnBoardingStatus(retailerId);
      return res.data;
    } catch (error) {
      console.error("Error in toggling onboarding status", error);
      throw error;
    }
  };

  return { toggleOnBoardingStatus };
}; 